define('drops/circleShape/circleShape',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    function CircleShape(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element
            .addClass('boxToBorderSize');
    };

    Drop.extend(CircleShape, Drop);

    CircleShape.typeName = 'CircleShape';

    CircleShape.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        this.applyPosition();

        var dropSize = this.data.size;
        var availableSize = dropSize.x < dropSize.y ? dropSize.x : dropSize.y;

        this.$circle = $('<div/>')
            .css({
                width: availableSize + 'px',
                height: availableSize + 'px'
            });

        this.renderStyles();

        this.$circle.appendTo(this.$element);
    };

    CircleShape.prototype.renderStyles = function () {
        // note: this will clear the border-radius
        Style.renderStyles(this, null, this.$circle);
        
        this.$circle.css('border-radius', '50%');
    };

    return CircleShape;
});
